<template>
  <div id="hp-service-shop-component" role="region" :data-brand="brand.substr(0,1).toLowerCase() + brand.substr(1)" :style="{backgroundImage: contentImg}">
    <div class="container">
      <div class="row">
        <div class="col-xs-12">
          <div class="shop-box">
            <ul class="nav nav-tabs" role="tablist">
              <li role="presentation">
                <a aria-controls="shop-filter2" data-toggle="tab" href="#shop-filter2" role="tab">Start Shopping</a>
              </li>
              <li class="active" role="presentation">
                <a aria-controls="service-filter2" data-toggle="tab" href="#service-filter2" role="tab">Get Service</a>
              </li>
            </ul>
            <div class="tab-content">
              <div class="tab-pane" id="shop-filter2" role="tabpanel">
                <div class="vehicle-browse-ajax">
                  <form class="vehicle-search-form" method="get">
                    <input class="inventory-type set-on-load" name="new" type="hidden" value="true">
                    <div class="form-group">
                      <label class="visuallyhidden" for="dropdown-vehicle-type">Select vehicle
                        type:</label>
                      <select aria-labelledby="dropdown-search-title" class="form-control vehicle-search search-inv-type" id="dropdown-vehicle-type" name="type">
                        <option data="true" value="new">New</option>
                        <option data="false" value="used">Used</option>
                      </select>
                      <i class="material-icons">keyboard_arrow_down</i>
                    </div>
                    <div class="form-group">
                      <label class="visuallyhidden" for="dropdown-vehicle-make">Select vehicle
                        make:</label>
                      <select aria-labelledby="dropdown-search-title" class="form-control vehicle-search vehicle-search-make" id="dropdown-vehicle-make" name="make">
                        <option value="default">{{brandName}}</option>
                      </select>
                      <i class="material-icons">keyboard_arrow_down</i>
                    </div>
                    <div class="form-group">
                      <label class="visuallyhidden" for="dropdown-vehicle-model">Select vehicle
                        model:</label>
                      <select aria-labelledby="dropdown-search-title" class="form-control vehicle-search vehicle-search-model" id="dropdown-vehicle-model" name="model">
                        <option value="default">Model</option>
                      </select>
                      <i class="material-icons">keyboard_arrow_down</i>
                    </div>
                    <div class="form-group">
                      <label class="visuallyhidden" for="dropdown-vehicle-year">Select vehicle
                        year:</label>
                      <select aria-labelledby="dropdown-search-title" class="form-control vehicle-search vehicle-search-year" id="dropdown-vehicle-year" name="year">
                        <option value="default">Year</option>
                      </select>
                      <i class="material-icons">keyboard_arrow_down</i>
                    </div>
                    <div class="form-group" id="search-submit">
                      <input aria-label="Click here to submit" class="btn btn-block btn-lg search-form-btn vehicle-search-submit" value="Search">
                    </div>
                  </form>
                  <br>
                  <span class="matching-vehicles-found text-center">
                    <div class="text-center">
                      <span class="match-count"><b>123</b></span>&nbsp; matching vehicles
                      found</div>
                  </span>
                </div>
                <div class="shop-inventory-buttons">
                  <div class="row">
                    <div class="col-sm-6 col-xs-12">
                      <a class="btn new-vehicles" href="#">Shop New Vehicles</a>
                    </div>
                    <div class="col-sm-6 col-xs-12">
                      <a class="btn pre-owned-vehicles" href="#">Shop Pre-Owned Vehicles</a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane active" id="service-filter2" role="tabpanel">
                <div class="service-buttons">
                  <div class="row">
                    <div class="col-sm-4 col-xs-12">
                      <a class="btn schedule-service" href="#">Book Service</a>
                    </div>
                    <div class="col-sm-4 col-xs-12">
                      <a class="btn order-parts" href="#">Order Parts</a>
                    </div>
                    <div class="col-sm-4 col-xs-12">
                      <a class="btn service-specials" href="#">Service Specials</a>
                    </div>
                  </div>
                </div>
                <div class="service-hours">
                  <div class="row">
                    <div class="col-xs-12 text-center">
                      <p>Service Department is open...</p>
                    </div>
                    <div class="col-sm-4 col-xs-12 text-center">
                      <div class="hours-box">
                        <span class="date">Mon - Fri</span><span>8:00 am - 5:00 pm</span>
                      </div>
                    </div>
                    <div class="col-sm-4 col-xs-12 text-center">
                      <div class="hours-box">
                        <span class="date">Sat</span><span>8:00 am - 5:00 pm</span>
                      </div>
                    </div>
                    <div class="col-sm-4 col-xs-12 text-center">
                      <div class="hours-box">
                        <span class="date">Sun</span><span>Closed</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['images'],
  data() {
    return {
      brand: this.$store.state.chosenBrand
    }
  },
  computed: {
    brandName () {
      if (this.brand === 'none') {
        return 'Brand';
      } else if (this.brand === 'infiniti' || this.brand === 'cjdr') {
        return this.brand.toUpperCase();
      } else {
        return this.brand.charAt(0).toUpperCase() + this.brand.slice(1);
      }
    },
    contentImg () {
      if (this.brand === 'cjdr' || this.brand === 'infiniti') {
        return 'url(' + this.images.lifestyleImages.defaultImage + ')';
      } else if (this.brand === 'none' || this.brand === 'honda') {
        return 'url(' + this.images.lifestyleImages.sedanImage + ')';
      } else if (this.brand === 'chevrolet' || this.brand === 'nissan' || this.brand === 'mitsubishi') {
        return 'url(' + this.images.lifestyleImages.truckImage + ')';
      } else {
        return 'url(' + this.images.lifestyleImages.suvImage + ')';
      }
    }
  },
  mounted() {
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
.visuallyhidden {
  display: none;
}
#hp-service-shop-component {
  background-position: center;
  background-repeat: no-repeat;
  background-blend-mode: multiply;
  background-color: rgb(0 0 0 / 0.5);
  padding-top: 5%;
  padding-bottom: 5%;
  font-size: 14px;
}
#hp-service-shop-component .shop-box {
  background: transparent;
  color: var(--primary-dark);
  -webkit-backdrop-filter: blur(12px);
  backdrop-filter: blur(12px);
  background-color: rgba(255, 255, 255, .35);
  border-radius: 6px;
}
#hp-service-shop-component .shop-box .nav-tabs {
  background: transparent;
  border: none;
  display: flex;
}
#hp-service-shop-component .shop-box .nav-tabs li {
  align-self: stretch;
  float: none;
  display: inline-block;
  text-align: center;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  border: 2px solid #ffffff;
  background-color: #B5B5B5;
  width: 35%;
  -webkit-transition: .3s all ease;
  -o-transition: .3s all ease;
  -moz-transition: all 0.3s ease;
  transition: .3s all ease;
}
#hp-service-shop-component .shop-box .nav-tabs li.active {
  border-bottom-color: #fff;
}
#hp-service-shop-component .shop-box .nav-tabs li:last-of-type {
  float: right;
}
#hp-service-shop-component .shop-box .nav-tabs li.active {
  background: transparent;
  border: 2px solid #ffffff;
  border-bottom: none;
  width: 65%;
}
#hp-service-shop-component .shop-box .nav-tabs li:last-child {
  border-left: none;
  border-top-left-radius: 0;
}
#hp-service-shop-component .shop-box .nav-tabs li:last-child:not(.active) {
  border-left: 2px solid #ffffff;
}
#hp-service-shop-component .shop-box .nav-tabs li.active:first-child {
  border-right: none;
}
#hp-service-shop-component .shop-box .nav-tabs li:first-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
#hp-service-shop-component .shop-box .nav-tabs li a {
  font-weight: 500;
  font-size: 16px;
  color: #58595B;
  border: none !important;
  background-color: transparent;
}
#hp-service-shop-component .shop-box .nav-tabs li:not(.active) a {
  color: var(--primary-dark);
}
#hp-service-shop-component .shop-box .nav-tabs li.active a {
  color: #ffffff;
  background-color: transparent;
}
#hp-service-shop-component .shop-box .nav-tabs li:after {
  content: " ";
  display: block;
  height: 3px;
  width: 50%;
  background: transparent;
  margin: auto;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all .3s ease;
}
#hp-service-shop-component .shop-box .nav-tabs li.active:after {
  background: #fff;
}
#hp-service-shop-component .tab-pane {
  padding: 30px 15px 15px;
  border: 2px solid #ffffff;
  background-color: transparent;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
}
#hp-service-shop-component .tab-pane.active, #hp-service-shop-component #shop-filter2.active, #hp-service-shop-component #service-filter2.active {
  background-color: transparent;
  border-top: none;
  min-height: 250px;
}
#hp-service-shop-component #shop-filter2.active {
  margin: auto;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  overflow: hidden;
  background-size: cover;
}
#hp-service-shop-component .vehicle-browse-ajax {
  width: 100%;
  max-width: 1024px;
  margin: 0 auto 25px;
  z-index: 2;
}
#hp-service-shop-component .form-group {
  flex-grow: 1;
  position: relative;
  border-radius: 6px;
}
#hp-service-shop-component .form-group:not(#search-submit) {
  background-color: transparent;
  color: #ffffff;
  font-weight: bold;
  font-family: var(--bold-text);
}
#hp-service-shop-component .form-group i {
  position: absolute;
  line-height: 48px;
  right: 12px;
  top: 0;
}
#hp-service-shop-component .form-control {
  display: block;
  width: 100%;
  height: 100%;
  line-height: 32px;
  position: relative;
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  z-index: 1;
  background-color: transparent;
  color: #ffffff;
  border: 2px solid #ffffff;
  border-radius: 0;
}
#hp-service-shop-component .search-form-btn.vehicle-search-submit {
  border: none;
  text-transform: uppercase;
  letter-spacing: 2px;
  line-height: 32px;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all .3s ease;
  background-color: #ffffff;
  color: var(--primary-dark);
  text-transform: capitalize;
  border-radius: 0;
}
#hp-service-shop-component .search-form-btn.vehicle-search-submit:hover {
  background-color: var(--primary-dark);
  color: #fff;
}
#hp-service-shop-component .matching-vehicles-found {
  font-size: 16px;
}
#hp-service-shop-component .service-buttons .col-sm-4.col-xs-12 {
  text-align: center;
}
#hp-service-shop-component .shop-inventory-buttons .btn, #hp-service-shop-component .service-buttons .btn {
  background: var(--primary-dark);
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 2px;
  text-transform: uppercase;
  padding: 20px;
  width: 100%;
  display: block;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all .3s ease;
}
#hp-service-shop-component .shop-inventory-buttons .btn:hover, #hp-service-shop-component .service-buttons .btn:hover {
  background: #fff;
  color: var(--primary-dark);
}
#hp-service-shop-component #service-filter2 .service-hours {
  margin-top: 35px;
}
#hp-service-shop-component #service-filter2 .service-hours .col-xs-12 p {
  font-size: 14px;
  margin-bottom: 15px;
}
body #hp-service-shop-component .matching-vehicles-found, body #hp-service-shop-component #service-filter2 .service-hours .col-xs-12 p {
  color: #fff;
}
#hp-service-shop-component #service-filter2 .hours-box {
  background: #f5f5f5;
  border-radius: 5px;
  padding: 5px;
}
#hp-service-shop-component #service-filter2 .hours-box .date {
  color: #58595B;
  margin-right: 10px;
}

@media(min-width: 768px) {
  #hp-service-shop-component .vehicle-search-form {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    justify-content: space-between;
  }
  #hp-service-shop-component .form-group {
    flex-basis: 20%;
  }
  #hp-service-shop-component .form-group:not(:last-child) {
    margin-right: 12px;
  }
}

@media (max-width: 767px) {
  #hp-service-shop-component #service-filter2 .hours-box, #hp-service-shop-component .shop-inventory-buttons .btn, #hp-service-shop-component .service-buttons .btn {
    margin-bottom: 10px;
    padding-left: 0px;
    padding-right: 0px;
  }
  #hp-service-shop-component .shop-box .nav-tabs li:after {
    width: 120px;
  }
  #hp-service-shop-component .container {
    width: 100%;
  }
  #hp-service-shop-component .shop-box .nav-tabs li a {
    font-size: 14px;
  }
}
</style>